export type TemplateArgs = Record<string, string | number | boolean>

/** Replaces each `{{ name }}` whose name is in `args`; other placeholders stay as written. */
export function resolveTemplate(template: string, args?: TemplateArgs) {
  if (!args) return template
  return template.replace(/{{\s*([^{}\s]+)\s*}}/g, (match, name: string) =>
    Object.hasOwn(args, name) ? String(args[name]) : match,
  )
}

/** Looks up `key` in `dict` and fills its template; a missing key yields undefined. */
export function createTranslator(dict: Record<string, string>) {
  return (key: string, args?: TemplateArgs): string => {
    const value = dict[key]
    return typeof value === "string" ? resolveTemplate(value, args) : value
  }
}
